
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUpdateQuestionLookingFor } from '../../../services/questionService'
import { RootState } from "../../../redux/store";
import { QuestionProps } from '../../../typings/register';
import QuestionUpdateHeader from './QuestionUpdateHeader';
import EditTagsQuestion from '../../../components/EditTagsQuestion';
import { updateMemberLookingFor } from '../../../services/memberService';
import { useHistory } from 'react-router-dom';

const UpdateLookingForQuestion = () => {

    const [isLoading, setIsLoading] = useState<boolean>();
    const [question, setQuestion] = useState<QuestionProps>();
    const { memberCode: myMemberCode } = useSelector((state: RootState) => state.member);
    let history = useHistory();

    useEffect(() => {
        getAndSetQuestion();
    }, [])


    const getAndSetQuestion = async () => {
        setIsLoading(true);
        const { data } = await getUpdateQuestionLookingFor(myMemberCode);
        setQuestion(data);
        setIsLoading(false);
    };

    const onSave = async (tags: number[]) => {
        if (question) {
            await updateMemberLookingFor(myMemberCode, tags);
            history.goBack();
        }

    };

    return (
        <>
            {
                question && question.tags ?
                    <>
                        <QuestionUpdateHeader />
                        <EditTagsQuestion
                            title={question.question}
                            subtitle={question.questionSubTitle}
                            buttonText={"שמור"}
                            tags={question.tags}
                            onSave={onSave}
                            questionMaxAsnwer={question.maxAnswer}
                            questionMinAsnwer={question.minAnswer}
                            selectedTagsValue={question.tags.filter(x => x.isSelected).map(x => x.value)}
                        />
                    </>
                    :
                    null
            }
        </>
    )
}

export default UpdateLookingForQuestion;